import _ from 'lodash';
import Note from './Note';
import withProbability from './lib/withProbability';

const noteExists = (noteIndex, instrument) => typeof instrument.notes[noteIndex] !== 'undefined';

// Return
export default programmer => [
  note => {
    if (!withProbability(.2)) return;
    note.logMutation('Delete note');

    note.active = false;
  },
  note => {
    if (!withProbability(.3) || !note.active) return;
    const options = [-2, -3, 2, 3]
      .filter( o => noteExists(note.noteIndex + o, note.instrument));

    const pick = _.sample(options);

    if (!withProbability(.5)) {
      note.transpose(pick);
      note.logMutation('Offset note by ' + pick);
    } else {
      note.logMutation('Added extra note with ' + pick + ' offset');
      return note.clone({ velocity: note.velocity * .8 }).transpose(pick);
    }
  },
  note => {
    if (
      !noteExists(note.noteIndex - programmer.octaveLength, note.instrument)
      || !withProbability(.3)
      || !note.active
    ) return;

     note.logMutation('add lower Octave');

    return note.clone({
      noteIndex: note.noteIndex - programmer.octaveLength,
      duration: '1m',
      velocity: note.velocity * .6,
    })
  },
  note => {
    if (
      !noteExists(note.noteIndex + programmer.octaveLength, note.instrument)
      || !withProbability(.4)
      || !note.active
    ) return;

     note.logMutation('add higher Octave');

    return note.clone({
      noteIndex: note.noteIndex + programmer.octaveLength,
      velocity: note.velocity * .5,
    }).adjustLength(0.7)
  },
  (note, allNotes) => {
    if (!withProbability(.3) || !note.active) return;
     note.logMutation('Longer duration');

    allNotes.forEach( n => n.adjustLength(1 + (Math.random() * 1.2) ));
  },
  (note, allNotes) => {
    if (!withProbability(.3) || !note.active) return;
    note.logMutation('shorten duration');

    note.adjustLength(.5);
  },
  (note, allNotes) => {
    // Variable velocity
    const maxEffect = .6;
    const amount = 1 - (Math.random() * maxEffect);
    note.logMutation('change velocity by ' + amount);

    allNotes.forEach( note => note.velocity *= amount );
  },
  note => {
    if (
      !noteExists(note.noteIndex + programmer.octaveLength, note.instrument)
      || !withProbability(.2)
      || !note.active
    ) return;

     note.logMutation('add higher Octave drone!');

    return note.clone({
      noteIndex: note.noteIndex + programmer.octaveLength,
      velocity: Math.max(note.velocity * .3, .4),
    }).adjustLength(4)
  }
  // (note, allNotes) => {
  //   // if (!withProbability(.1) || !note.active) return;
  //   console.log('lol');
  //   note.logMutation('add repetition');

  //   allNotes.push(
  //     note.clone({
  //       velocity: note.velocity * .8,
  //     }).delay('4n') // NOTE: this on
  //   );
  // }

  // (note, allNotes) => {
  // This one doesn't work with the current setup
  //   if (!withProbability(.01)) return;
  //    note.logMutation('scheduled repeat');

  //   const addedNotes = allNotes.map( n => n.clone({
  //     time: '+1m',
  //     repetition: true,
  //     // velocity: n.velocity *= .6
  //   }));

  //   allNotes.push.apply(allNotes, addedNotes);
  // }
]



// WEBPACK FOOTER //
// ./src/mutations.js